import { Navigate, Route, Routes, useLocation } from "react-router";
import { useAuth } from "react-oidc-context";
import { LoginPage } from "./pages/LoginPage";
import { MeetingsPage } from "./pages/MeetingsPage";
import { UploadPage } from "./pages/UploadPage";
import { MeetingPage } from "./pages/MeetingPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TabBar } from "./components/TabBar";

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-dvh flex flex-col">
      <main className="flex-1 safe-top pb-24">{children}</main>
      <TabBar />
    </div>
  );
}

export function App() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.isLoading || auth.activeNavigator) {
    return <div className="min-h-dvh grid place-items-center text-slate-400">로그인 확인 중…</div>;
  }
  if (!auth.isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<LoginPage error={auth.error?.message} from={location.pathname} />} />
      </Routes>
    );
  }
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<MeetingsPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/meetings/:id" element={<MeetingPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/callback" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
